import {
  createDeleteSlice,
  createInsertSlice,
} from 'components/RichTextEditor/processor/actions/textProcessorActions'
import {
  ITextProcessorMiddleware,
  ISlice,
  IRange,
} from 'components/RichTextEditor/processor/constants'
import { createRange } from 'components/RichTextEditor/processor/range'
import {
  getSelection,
  getSlices,
  getSlicesAt,
} from 'components/RichTextEditor/processor/selectors/textProcessorSelectors'

import { getExpression } from '../selectors/getExpression'

export const createSuggestionsMiddleware = (
  sliceType: string,
  expressionPrefix: string,
  getSliceFromExpression: (expression: string, range: IRange) => Omit<ISlice, 'type'> | null,
): ITextProcessorMiddleware => {
  return (api) => (next) => (action) => {
    next(action)

    if (action.type !== 'insert' && action.type !== 'delete' && action.type !== 'select') {
      return
    }

    const slices = getSlices(api.getState()).filter((slice) => slice.type === sliceType)
    for (const slice of slices) {
      api.dispatch(createDeleteSlice(slice))
    }

    const expression = getExpression(api.getState(), expressionPrefix)

    if (!expression) {
      return
    }

    const selection = getSelection(api.getState())

    if (selection.start !== selection.end) {
      return
    }

    const existingSlices = getSlicesAt(api.getState(), selection.start)
    if (existingSlices.length) {
      return
    }

    const start = selection.start - expression.length
    const range = createRange(start, expression.length)
    const slice = getSliceFromExpression(expression, range)
    if (!slice) {
      return
    }

    api.dispatch(createInsertSlice({ ...slice, type: sliceType }))
  }
}
